export default {
  api: "http://192.168.1.4:5000/api/",
  media: "http://192.168.1.4:5000/uploads/",
};
